/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0+2023-08-07",
    versionName: "nightly 2023-08-07",
    versionChannel: "nightly",
    buildDate: "2023-08-07T00:19:50.334Z",
    commitHash: "37085767f643c3bb9c4292b1f999aa36587e0a29",
};
